import React from "react";

export default function FormError(props) {
  return <small className="error">{props.children}</small>;
}
